import { useEffect } from 'react';
import './GenerateProgress.less';
import loading from '@/assets/texture/generate-loading.png';
import { ConfigProvider, Progress } from 'antd';
export default function GenerateProgress(props) {
  console.log('progress222===', props.percent);

  useEffect(() => {}, []);
  return (
    <div className="generate-progress">
      <img className="generate-progress-loading" src={loading}></img>
      <span className="generate-progress-title">generating...</span>
      <ConfigProvider
        theme={{
          components: {
            Progress: {
              defaultColor: '#A0F00F',
              remainingColor: '#313131',
            },
          },
        }}>
        <Progress style={{ width: 180 }} showInfo={false} percent={props.percent}></Progress>
      </ConfigProvider>
    </div>
  );
}
